import { Link } from "react-router-dom";
import { currentBrand } from "@/lib/brand";

export default function Landing() {
  const brand = currentBrand();

  return (
    <section className="container py-20">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">
          {brand.name}
        </p>
        <h1 className="mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">
          {brand.hero}
        </h1>
        <p className="mt-6 text-lg text-muted-foreground">{brand.tagline}</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/dashboard/signup"
            className="rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Get started — it's free
          </Link>
          <Link
            to="/dashboard/login"
            className="rounded-md border px-5 py-2.5 text-sm font-medium hover:bg-secondary"
          >
            Log in
          </Link>
        </div>
        <p className="mt-6 text-xs text-muted-foreground">
          Connect FreeAgent in 60 seconds. See your revenue, profit, cash and tax in
          one place. Share a read-only snapshot with your accountant or adviser.
        </p>
      </div>
    </section>
  );
}
